const Staff = [
  {
    name: "Yasmina Salem-Dehane",
    role: "",
    description:
      "Before joining Lead-Up in 2017, Yasmina held junior positions as Clinical Research Associate (Henri Mondor Hospital, Medical Devices - Cardiology) and then Product Manager (Coloplast, Medical Devices - Urology). Yasmina has a Master's degree in Pharmacology from the Paris Descartes University and she completed her training with a Master’s degree in Health Marketing, Negotiation and Sales Option at the Pierre and Marie Curie University (Paris).",
  },
  {
    name: "Gildas Auffret",
    role: "President",
    description:
      "Before joining Lead-Up in 2006, Gildas spent more than 12 years in French and international positions (marketing and sales) in several large pharmaceutical companies (Bayer, MSD, Aventis) working in various therapeutic areas (Thrombosis, Cardio/Lipido, Rheumatology).  Gildas has a Master of Business in Pharmaceutical Marketing (Paris VI) and a Master in Biochemistry (Rennes, France).",
  },
  {
    name: "Karen Scott",
    role: "Project Director",
    description:
      "Karen began her career in the healthcare public relations field, in the USA and France, before moving in-house to handle product communications initiatives for international pharmaceutical companies in France (Aventis) and Switzerland (Actelion). Karen has a Bachelor of Science from Georgetown University (Washington, DC, USA) and is a member of the British healthcare Business Intelligence Association.",
  },
  {
    name: "Rosa Siali",
    role: "Senior Medical Writer",
    description:
      "Rosa began her career as scientist and scientific manager in preclinical research and development of drugs, medical devices and bioassays.  She has worked in the fields of biotechnology, microbiology, immunology, oncology and ophthalmology in Belgium, France and Switzerland (Cis-Bio-Industrie, Solvay, Merck Serono, Bioracs, Therapol). She has extensive experience in medical writing (congress reports, post-meeting summaries, slide-kits for medical and marketing material, etc) on different topics and fields. Rosa has a PhD in Biochemistry and Medical Bio-Engineering from the University of Paris and a Master’s degree in English and German (University of Paris).",
  },
  {
    name: "Nadia Alaoui",
    role: "Project Manager",
    description:
      "Before joining Lead-Up in 2009, Nadia held two training positions in regulatory affairs (Wyeth/Pfizer, Neurology) and marketing (GSK, Pediatric Vaccines).  She then spent one year at LFB (Laboratoires Français de Biotechnologie) as Junior Product Manager in the Intensive Care Unit. Nadia received her PharmD with a specialization in pharmaceutical production and regulatory affairs from the University of Tours and has an MBA in Marketing Management from ESG Management School (Paris).",
  },
  {
    name: "Ayesha Powell",
    role: "Office Manager",
    description:
      "Ayesha has been managing Lead-Up’s front desk since 2007 and when you phone, the chances are that she will be the first person you speak to. She speaks several languages including Italian, German, French and Arabic and her richly varied career has included theater production and company management as well as copy-editing and administrative positions in the pharmaceutical industry.",
  },
];

export default Staff;
